// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3qRy1","title":"Info_title__2BjSy","selects":"Info_selects__12hSJ","requiredAsterisk":"Info_requiredAsterisk__1cN1k"};